"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSegment = exports.logoutFromMovistar = exports.logoutConvergente = exports.logoutTELCO = exports.mapContextParamsToCustoReq = exports.getSeoInfoFromContext = exports.mapContextParamsToPageEvent = exports.QUEUE_NAMES = exports.isPriority = void 0;
/* eslint-disable camelcase */
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const next12_utils_metrics_1 = require("@gcloud-npm/next12.utils.metrics");
/**
 * Recupera si el usuario es priority o no
 * @returns {object} res with two props subseg and priorityCheck
 */
const isPriority = () => {
    let subseg = "";
    let priorityCheck = false;
    try {
        subseg = (0, next12_utils_common_1.getCookie)("subseg");
        if (subseg === "R7") {
            priorityCheck = true;
        }
    }
    catch (e) {
        // Mandar errores
    }
    return {
        subseg,
        priorityCheck,
    };
};
exports.isPriority = isPriority;
/* NOOKINFO HELPERS */
exports.QUEUE_NAMES = {
    GLOBAL: "Context",
    CUSTO: "Context-Custo-Params",
    TEST: "Context-Custo-Test",
    PAGE: "Context-Page-Params",
    // Cola para escribir testVersion desde CustomizerComponent
    CUSTO_TEST_VERSION: "CUSTO_TEST_VERSION",
    // Cola para escuchar testVersion desde CustomizerComponent
    CUSTO_TEST_VERSION_RESULT: "CUSTO_TEST_VERSION_RESULT",
    // ESta escucha los parametros que manda la pagina
    SEO_PARAMS: "SEO_PARAMS",
    // Esta emite el seo ya solicitado
    SEO_DATA: "SEO_DATA",
    // Evento para modificar caracteristica permitidas de context
    OPEN_CONTEXT_CHANGES: "OPEN_CONTEXT_CHANGES",
};
const mapContextParamsToPageEvent = (observerName, callBackNook) => {
    let observer = observerName;
    if (!observer) {
        observer = `observer${Date.now()}`;
    }
    if ((0, next12_utils_common_1.isFrontApp)() && window && window.nookInfoExchange) {
        window.nookInfoExchange.registerAsObserver(exports.QUEUE_NAMES.PAGE, observer, (message) => {
            const object = (0, next12_utils_metrics_1.createPageEventObject)(message);
            if (typeof callBackNook === "function") {
                callBackNook(object);
            }
        }, false);
    }
};
exports.mapContextParamsToPageEvent = mapContextParamsToPageEvent;
const getSeoInfoFromContext = (observerName, callBackNook) => {
    let observer = observerName;
    if (!observer) {
        observer = `observer${Date.now()}`;
    }
    if ((0, next12_utils_common_1.isFrontApp)() && window && window.nookInfoExchange) {
        window.nookInfoExchange.registerAsObserver(exports.QUEUE_NAMES.SEO_DATA, observer, (seoData) => {
            if (typeof callBackNook === "function") {
                callBackNook(seoData);
            }
        });
    }
};
exports.getSeoInfoFromContext = getSeoInfoFromContext;
const mapContextParamsToCustoReq = (observerName, callBackNook) => {
    let observer = observerName;
    if (!observer) {
        observer = `observer${Date.now()}`;
    }
    if ((0, next12_utils_common_1.isFrontApp)() && window && window.nookInfoExchange) {
        window.nookInfoExchange.registerAsObserver("Context-Custo-Params", observer, (message) => {
            try {
                if (message) {
                    const urlParams = (0, next12_utils_common_1.getUrlParams)(true, [
                        /recomEnterprise/g,
                        /percentile/g,
                        /levCode/g,
                        /prodCode/g,
                        /promoCode/g,
                        /ctz_c/g,
                        /turingDev/g,
                        /productOffering/g,
                        /webCode/g,
                        /context.*/g,
                        /custoHost/g,
                        /businessClusters/g,
                        /recomType/g,
                        /userType/g,
                        /ctzTest/g,
                    ]);
                    // Cuidado -> UserType es Legado/Telco/'' e infoRecom.userType es cliente-util/cliente-no-util.
                    const { subseg, gwIspI3D, gwIsp, userType, clientIDs, device, i3Ready, pageSegment, userPriority, creativitiesHistory, referalAP, environment, infoRecom, userCUCFijoHash, userCUCMovilHash, } = message;
                    let custoObject = {
                        i3Ready,
                        SEG_NAV: pageSegment,
                        i3_cuc: userCUCFijoHash,
                        i3_cucm: userCUCMovilHash,
                        ga: clientIDs.ga,
                        pageId: clientIDs.pageId,
                        paid: clientIDs.sessId,
                        ctz_c: "true",
                        originUrl: window.location.href,
                        userType: infoRecom && infoRecom.userType
                            ? infoRecom.userType
                            : undefined,
                        context: {
                            subseg,
                            creativitiesHistory,
                            gw_isp: gwIsp,
                            gw_isp_d: gwIspI3D,
                            isLogado: userType ? "true" : "false",
                            tipoUsuario: userType,
                            deviceType: device,
                            seg_nav: pageSegment,
                            isPriority: userPriority ? "true" : "false",
                            referal_ap: referalAP,
                            environment,
                            currentURL: environment.currentURL,
                        },
                    };
                    if (urlParams.context && typeof urlParams.context === "object") {
                        urlParams.context = Object.assign(Object.assign({}, custoObject.context), urlParams.context);
                    }
                    custoObject = Object.assign(Object.assign({}, custoObject), urlParams);
                    if (typeof callBackNook === "function") {
                        callBackNook(custoObject);
                    }
                }
            }
            catch (e) {
                console.log(e);
                throw new Error(e);
            }
        }, false);
    }
};
exports.mapContextParamsToCustoReq = mapContextParamsToCustoReq;
/**
 * Cierra sesión en Telco
 */
const logoutTELCO = (url) => {
    if ((0, next12_utils_common_1.isFrontApp)()) {
        document.location.assign(url);
        return null;
    }
};
exports.logoutTELCO = logoutTELCO;
/**
 * Cierra sesión de usuario.
 */
const logoutConvergente = (url) => {
    if ((0, next12_utils_common_1.isFrontApp)()) {
        localStorage.removeItem("codigoOrden");
        localStorage.removeItem("numtlf");
        sessionStorage.removeItem("nameuser");
        sessionStorage.removeItem("urlhomeprivada");
        sessionStorage.removeItem("cclivr$$.api.misDatos");
        document.location.assign(url);
    }
};
exports.logoutConvergente = logoutConvergente;
const logoutFromMovistar = (backToHome = false, userType) => {
    if ((0, next12_utils_common_1.isFrontApp)()) {
        const urlToGo = backToHome
            ? "https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html?destino=https%3A%2F%2Fwww.movistar.es%2F"
            : `https://www.movistar.es/mimovistar-cliente/es-es/particulares/cclivr/logout.html?destino=${window.location.href}`;
        if (userType === "Telco") {
            (0, exports.logoutTELCO)(urlToGo);
        }
        else if (userType === "Legado") {
            (0, exports.logoutConvergente)(urlToGo);
        }
        sessionStorage.removeItem("cmsNameUser");
        sessionStorage.removeItem("cmsIsPriority");
        sessionStorage.removeItem("cmsContext");
    }
};
exports.logoutFromMovistar = logoutFromMovistar;
/**
 * Returns page segment
 * @return {string} 'particulares' by default
 */
const getSegment = () => {
    if ((0, next12_utils_common_1.isFrontApp)()) {
        let res = "";
        // intentamos por url empresas
        const { pathname } = window.location;
        if (pathname.indexOf("/empresas") === 0) {
            res = "empresas";
        }
        // intentamos por url particulares
        if (pathname.indexOf("/particulares") === 0 ||
            pathname.indexOf("/cliente/areaprivada") === 0) {
            res = "particulares";
        }
        let cookieNav = null;
        try {
            cookieNav = (0, next12_utils_common_1.getCookie)("SEG_NAV");
        }
        catch (err) {
            cookieNav = null;
        }
        if (!res && cookieNav && cookieNav !== "" && cookieNav !== "undefined") {
            res = cookieNav;
        }
        // en caso de no detectar por url, y en caso de que la cookie venga vacía
        if (!res) {
            res = "particulares";
        }
        return res;
    }
};
exports.getSegment = getSegment;
//# sourceMappingURL=index.js.map